import useSubscription from '../../hooks/useSubscription';
import styles from './registrationTitle.module.scss';

const RegistrationTitle = () => {
  const { subscription } = useSubscription();

  return (
    <>
      <h2 className={subscription?.hasRequest ? styles.registrationTitle : ''}>
        Détails de votre abonnement
      </h2>
      {subscription?.hasRequest && (
        <p className={styles.message}>
          Une demande de modification d&apos;abonnement est en attente...
        </p>
      )}
    </>
  );
};

export default RegistrationTitle;
